<template>
  <div class="edition-table">
    <table>
      <thead>
        <th>Quartos</th>
        <th class="edition-table__close">Fechar</th>
        <th class="edition-table__cta">CTA</th>
        <th class="edition-table__ctd">CTD</th>
        <th class="edition-table__discount">Desconto (%)</th>
        <th class="edition-table__value">Valor</th>
        <th class="edition-table__disp-lestbook">
          Disp. Let’s Book
        </th>
        <th class="edition-table__priority">
          Prioridade
          <InfoTooltip
            :text="infoText"
            :tooltipMinWidth="250"
            class="tooltip-space"
          />
        </th>
        <th class="edition-table__restriction">Restrição mín. de noites</th>
      </thead>
      <tbody>
        <!-- LINHA -->
        <tr v-for="(room, i) in rooms" :key="`room-${room.codigoQuarto || i}`">
          <!-- QUARTOS -->
          <td class="td__padd">
            {{ room.quarto }}
            <span v-if="room.base" class="td__highlight-blue"
              >[Quarto base]</span
            >
          </td>

          <!-- FECHAR -->
          <td class="td__padd">
            <InputCheckbox v-model="room.fechado" :checked="room.fechado" />
          </td>

          <!-- CTA -->
          <td class="td__padd">
            <InputCheckbox v-model="room.cta" :checked="room.cta" />
          </td>

          <!-- CTD -->
          <td class="td__padd">
            <InputCheckbox v-model="room.ctd" :checked="room.ctd" />
          </td>

          <!-- DESCONTO - HABILITADO -->
          <td v-if="!disabledDiscount(i, date)">
            <TableInputCell
              v-model="rooms[0].desconto"
              :id="`${room.quarto}-desconto`"
              :currency="true"
              :min="0"
              :max="99"
              :prefix="'-'"
              :sufix="'%'"
              type="number"
              placeholder=""
            />
          </td>
          <!-- DESCONTO DESABILITADO -->
          <td v-else class="td__padd">
            <div class="discount-disabled disabled">
              <span>-</span>
              <span class="discount-disabled--value">{{
                rooms[0].desconto
              }}</span>
              <span>%</span>
            </div>
          </td>

          <!-- VALOR -->
          <td class="disabled">
            <TableInputCell
              v-if="room.valor || room.valor > -1"
              v-model="room.valor"
              :id="`${room.quarto}-price`"
              :prefix="getCurrencySymbol"
              type="number"
              placeholder="0,00"
              disabled
            />
          </td>

          <!-- DISP. LET’S BOOK -->
          <td>
            <TableInputCell
              v-if="room.quantidadeDisponivel || room.quantidadeDisponivel > -1"
              v-model="room.quantidadeDisponivel"
              :id="`${room.quarto}-disponibility`"
            />
          </td>

          <!-- PRIORIDADE -->
          <td class="td__padd">
            <InputCheckbox
              v-model="room.prioridadeLB"
              :checked="room.prioridadeLB"
            />
          </td>

          <!-- RESTRIÇÃO MÍN. DE NOITES -->
          <td class="rest-td">
            <b-row no-gutters>
              <b-col class="td">
                <TableSelectCell
                  :options="minNightsOptions"
                  :value="
                    minNightsOptions.find(
                      (option) => +option.value === +room.tipoMinimoNoites
                    )
                  "
                  @change="room.tipoMinimoNoites = $event.value"
                />
              </b-col>
              <b-col class="td d-flex align-items-center" cols="3">
                <TableInputCell
                  v-if="room.minimoNoites || room.minimoNoites > -1"
                  v-model="room.minimoNoites"
                  :id="`${room.quarto}-nightsNumber`"
              /></b-col>
            </b-row>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/** ======================================================== */
/** Componente da tabela de visualização da tarifa flutuante */
/** ======================================================== */
import { mapGetters } from 'vuex'
import InputCheckbox from '@/components/_base/elements/InputCheckbox'
import InfoTooltip from '@/components/_base/patterns/InfoTooltip'
import TableInputCell from './TableInputCell'
import TableSelectCell from './TableSelectCell'

export default {
  name: 'FloatingTable',
  components: {
    InputCheckbox,
    InfoTooltip,
    TableInputCell,
    TableSelectCell
  },
  props: {
    /** Configuração dos quartos */
    rooms: {
      type: Array,
      default: () => []
    },
    /** Pegar data */
    date: {
      type: [String, Date],
      default: null
    }
  },
  data() {
    return {
      minNightsOptions: [
        { text: 'Selecione', value: null },
        { text: 'Chegando em', value: 1 },
        { text: 'Passando por', value: 2 }
      ],
      infoText:
        'Ao marcar como prioridade, as disponibilidades e restrições ignoram qualquer dado que vier de integração.'
    }
  },
  computed: {
    ...mapGetters('hotel', ['getCurrency', 'getCurrencySymbol'])
  },
  methods: {
    /** Se deve desabilitar o desconto
     * @param i - Index da linha de edição
     * @param date - Data selecionada
     */
    disabledDiscount(i, date) {
      return (
        i !== 0 ||
        new Date(date).toISOString() < new Date().toISOString().slice(0, 10)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
$cell-padding: 12px 15px;

.tooltip-space {
  margin-left: 7px;
}

.edition-table {
  max-width: 1236px;

  &__close {
    width: 77px;
    min-width: 77px;
  }

  &__cta {
    width: 77px;
    min-width: 77px;
  }

  &__ctd {
    width: 77px;
    min-width: 77px;
  }

  &__discount {
    width: 116px;
    min-width: 116px;
  }

  &__value {
    width: 77px;
    min-width: 77px;
  }

  &__disp-lestbook {
    width: 120px;
    min-width: 120px;
  }

  &__priority {
    width: 116px;
    min-width: 116px;
  }

  &__restriction {
    width: 170px;
    min-width: 170px;
  }

  table {
    th {
      padding: $cell-padding;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }

      &.disabled {
        background: #f7f7f7;
        ::v-deep .table-cell input {
          background: #f7f7f7;
        }
      }
    }

    th {
      font-weight: font-weight('weight-medium');
    }

    .td {
      padding: 0;

      &__padd {
        padding: $cell-padding;
        ::v-deep .input-checkbox {
          margin: 0px auto !important;
          display: table;
        }
      }

      &__highlight-blue {
        font-weight: font-weight('weight-medium');
        color: $blue;
      }
    }

    .rest-td {
      .td {
        &:first-child {
          border-right: 1px solid $gray-border;
        }

        &:last-child {
          ::v-deep {
            .content-wrapper {
              padding: {
                left: 10px;
                right: 10px;
              }
            }
          }
        }
      }
    }
  }
}

.discount-disabled {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &--value {
    flex: 1;
    padding: 1px 2px;
  }
}
</style>
